import type { Environment } from './environment.type';

export const environment: Environment = {
  production: false,
  appUiUrl: 'https://dev.csrd.halfserious.com/',
  appApiUrl: 'https://api.csrd.halfserious.com',
  refreshTokensTimerDue: 5 * 60 * 1000, // 5 minutes
  defaultLanguage: 'fr',
};
